import _pt from "prop-types";
import * as React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
var Undo = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$ariaHidden = _ref['aria-hidden'],
      ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
      className = _ref.className,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      title = _ref.title,
      titleId = _ref.titleId;
  var numericSize = size === 'medium' ? 16 : size === 'small' ? 14 : 12;
  return ___EmotionJSX("svg", {
    viewBox: "0 0 18 18",
    "aria-hidden": ariaHidden,
    className: className,
    height: numericSize,
    ref: ref,
    role: "img",
    width: numericSize,
    "aria-labelledby": titleId
  }, title === undefined ? ___EmotionJSX("title", {
    id: titleId
  }, 'Undo') : title ? ___EmotionJSX("title", {
    id: titleId
  }, title) : null, ___EmotionJSX("path", {
    fill: color,
    d: "M5.833 5.508l1.855.701c.518.196.78.774.587 1.292a.998.998 0 01-1.289.583L3.342 6.707c-.4-.15-.66-.538-.65-.965l.094-3.694a.998.998 0 011.026-.973c.553.015.99.476.976 1.03l-.044 1.72.107-.085C8.255 1.357 12.94 2.176 15.316 5.57c2.376 3.393 1.542 8.075-1.861 10.459-3.404 2.383-8.089 1.564-10.465-1.829-.268-.457-.133-.875.407-1.252.54-.378.951-.344 1.234.103l.003-.002c1.742 2.489 5.178 3.089 7.674 1.341 2.496-1.747 3.107-5.181 1.364-7.67-1.742-2.488-5.178-3.088-7.674-1.34-.064.045-.12.088-.165.13z",
    fillRule: "evenodd"
  }));
});
Undo.propTypes = process.env.NODE_ENV !== "production" ? {
  'aria-hidden': _pt.bool,
  className: _pt.string,
  color: _pt.string,
  size: _pt.oneOf(['xsmall', 'small', 'medium']),
  title: _pt.string,
  titleId: _pt.string
} : {};
export default Undo;